import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  logInUser,
  logOutUser,
} from '../../modules/agent';

const initialState = {
  credentials: {
    email: '',
    password: '',
  },

  errorMessage: ''
};

class Login extends Component {

  state = {
    ...initialState,
  };

  handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { name, value } = e.currentTarget;
    const { credentials } = this.state;
    credentials[name] = value;
    this.setState({ credentials });
  };

  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const { logInUser, history: { push } } = this.props;

    this.setState(Object.assign(this.state, {
      errorMessage: ''
    }));

    logInUser(this.state.credentials)
      .then(() => push('/'))
      .catch(e => {
        const error = e.response && e.response.data && e.response.data.error;

        this.setState(Object.assign(this.state, {
          errorMessage: (error && error.message) ||'Login Failed'
        }));
      });
  };

  render() {
    const { credentials, errorMessage } = this.state;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <div>
                <style>{'body { background-image: url(/static/media/login-page-bg.jpg); background-repeat: no-repeat; background-size: cover;  }'}</style>
          </div>
          <Row className="justify-content-center">
            <Col lg="8" md="10">
              <CardGroup>
                <Card className="p-4 col-lg-6 col-md-12">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                    <div>
                          <img src={require('../../assets/img/brand/Australia.jpg')}
                                alt="font"
                                display = "none"
                                width={0} height={0} />
                          <img src={require('../../assets/img/brand/ncl-logo-hor.png')}
                                alt="logo"
                                align = "center"
                                width={260} height={60} />
                    </div>
                      <p className="text-muted">Sign In to your account</p>
                      <FormGroup>
                        <p>User email</p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={credentials.email}
                            onChange={this.handleChange}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <p>Password</p>
                        <InputGroup className="mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={credentials.password}
                            onChange={this.handleChange}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <Row>
                        {
                          !!errorMessage && (
                            <Col xs="12">
                              <Alert color="danger" className="text-center">
                                {errorMessage}
                              </Alert>
                            </Col>
                          )
                        }

                        <Col xs="6">
                          <Button color="primary" type="submit" className="px-4">Login</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Link to="/forgot-password">
                            <Button color="link" className="px-0">Forgot password?</Button>
                          </Link>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
                <Card className="text-white bg-primary py-5 col-lg-6 col-md-12">
                  <CardBody className="text-center">
                    <div>
                      <h2>Sign up</h2>
                      <p>Don't have an account?</p>
                      <Link to="/register">
                        <Button color="primary" size="lg" className="mt-3" active>Register Now </Button>
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth && state.auth.user,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logInUser,
  logOutUser,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js